<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useWizardStore } from '../stores/wizard'
import { useChartStore } from '../stores/chart'
import { useVotesStore } from '../stores/votes'
import { isKioskMode } from '../settings'
import Layout from '../components/Layout.vue'
import Title from '../components/elements/Title.vue'
import ContentBox from '../components/elements/ContentBox.vue'
import Track from '../components/tracks/Track.vue'
import TrackPosition from '../components/votes/TrackPosition.vue'
import Ranking from '../components/share/Ranking.vue'
import ThankYou from '../components/share/ThankYou.vue'
import PrimaryButton from '../components/elements/PrimaryButton.vue'
import ReloadIcon from '../assets/icons/reload.svg'
import JoeSingalongTrain from '../components/temporary/JoeSingalongTrain.vue'

const wizard = useWizardStore()
const chart = useChartStore()
const votes = useVotesStore()

let timeoutId = null

const reset = () => {
  wizard.$reset()
  votes.$reset()
}

onMounted(() => {
  if (isKioskMode) {
    timeoutId = setTimeout(() => {
      reset()
    }, 60000)
  }
})

onUnmounted(() => {
  if (timeoutId) {
    clearTimeout(timeoutId)
    timeoutId = null
  }
})

const showJoeSingalongTrain = chart.listId == 413 && new Date().getFullYear() === 2026 // Use the year, by lack of an edition id.
</script>

<template>
  <Layout>
    <template #sidebar>
      <ThankYou />
      <JoeSingalongTrain v-if="showJoeSingalongTrain" />
    </template>
    <ContentBox class="md:hidden">
      <ThankYou />
      <JoeSingalongTrain v-if="showJoeSingalongTrain" />
    </ContentBox>
    <ContentBox class="!bg-element space-y-2">
      <div class="space-y-2">
        <Title class="text-center">Jouw Top {{ chart.constraints.minVotes }}</Title>
        <Ranking :tracks="votes.topVotes" />
        <div class="divide-y divide-solid divide-element-dark space-y-1">
          <div
            v-for="[position, track] in votes.topVotes"
            :key="track.id"
            class="flex relative bg-accent text-accent-c shadow-md pl-3"
          >
            <TrackPosition :position="position" />
            <Track :track="track" />
          </div>
        </div>
      </div>
      <div v-if="votes.extraVotes.length" class="space-y-2">
        <div class="divide-y divide-solid divide-element-dark space-y-2">
          <Track v-for="[, track] in votes.extraVotes" :key="track.id" :track="track" />
        </div>
      </div>
    </ContentBox>
    <template #bar>
      <div class="h-full flex items-center justify-between">
        <PrimaryButton v-if="isKioskMode" type="white" class="flex items-center shadow-md pr-4" @click="reset">
          <ReloadIcon class="h-6" />
          Opnieuw stemmen
        </PrimaryButton>
        <div v-else class="w-12 h-12" @click="reset" />
      </div>
    </template>
  </Layout>
</template>
